import React, { FC, ReactNode, useMemo } from 'react';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import { DATE_FORMAT } from '../../constants';
import './AdminIsoDate.scss';
import classNames from 'classnames';

interface Props {
  isoDate?: string | null;
  otherwise?: ReactNode;
  className?: string;
}

export const AdminIsoDate: FC<Props> = ({ isoDate, className, otherwise = '-' }) => {
  const value = useMemo(() => {
    if (typeof isoDate === 'string') {
      const date = parseISO(isoDate);

      if (isValid(date)) {
        return format(date, DATE_FORMAT);
      }
    }

    return otherwise;
  }, [isoDate, otherwise]);

  return <span className={classNames('AdminIsoDate', className)}>{value}</span>;
};
